import { Message } from "../../components/chat/chat";
import { MESSAGE_TYPES, MAX_AUDIO_RESPONSE_LENGTH } from "./constants";
import { lerTextoEmVoz } from "../../util/voice";
import { isBrowser } from "../../util/env-utils";

const getPortalUrl = (): string => {
  if (process.env.PUBLIC_URL) {
    return process.env.PUBLIC_URL;
  }
  if (isBrowser && window.STATICS_ENDPOINT) {
    return window.STATICS_ENDPOINT;
  }
  return isBrowser ? window.location.origin : "";
};

/**
 * Converte paths internos em texto puro que começam com `app/` ou `/app/`
 * em URLs absolutas apontando para o portal.
 *
 * NÃO modifica:
 * - Links em markdown (ex: `[texto](/app/foo)`)
 * - URLs absolutas (http, https)
 * - Paths semelhantes como `/apps/...` ou `webapp/...`
 *
 * Exemplos que SERÃO substituídos:
 *   /app/servico
 *   app/servico/usuario?id=1
 *
 * Exemplos que NÃO serão modificados:
 *   https://portal.pe.gov.br/app/servico
 *   [texto](/app/servico)
 *   webapp/servico
 *   /apps/servico
 */
export const processInternalLinks = (text: string): string => {
  const portalUrl = getPortalUrl();
  return text.replace(/(^|\s)\/?(app\/[^\s]+)/g, `$1${portalUrl}/$2`);
};

export const formatTime = (): string => {
  return new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const extractMarkdownLink = (text: string): string | null => {
  const match = text.match(/\[(.*?)\]\((https?:\/\/[^\s)]+)\)/);
  return match ? match[2] : null;
};

export const createErrorMessage = (): Message => ({
  from: MESSAGE_TYPES.LIS,
  text: "Desculpe, ocorreu um erro ao processar sua mensagem. Por favor, tente novamente.",
  time: formatTime(),
  type: MESSAGE_TYPES.TEXT,
});

export const handleAudioResponse = (response: string): void => {
  if (response.length > MAX_AUDIO_RESPONSE_LENGTH) {
    const firstSentence = response.split(".")[0];
    const hasLink = extractMarkdownLink(response);
    const message = `${firstSentence}${
      hasLink ? ".  Click no link para mais informações." : ""
    }`;
    lerTextoEmVoz(message);
    return;
  }
  lerTextoEmVoz(response);
};

export const createLisMessage = (response: string): Message => ({
  from: MESSAGE_TYPES.LIS,
  text: processInternalLinks(response.toString()),
  time: formatTime(),
  type: MESSAGE_TYPES.TEXT,
});

export const createLisAudioMessage = ({
  text,
  audioUrl,
}: {
  text: string;
  audioUrl: string | null;
}): Message => ({
  from: MESSAGE_TYPES.LIS,
  text: processInternalLinks(text),
  time: formatTime(),
  type: MESSAGE_TYPES.AUDIO,
  audioUrl: audioUrl || undefined,
});
